<div class="stage container">
    <div class="column-wrapper">
        <div class="forgot-password-wrapper">
            <form class="forgot-password raised">
                <h1>Password Reset</h1>
                <b2c-content-host [b2cFrameSource]="b2cFrameSource" [b2cFrameHeight]="b2cFrameHeight"></b2c-content-host>            
            </form>
        </div>
    </div>
</div>